import { forwardRef } from 'react';
import MobileHeroBanner from './MobileHeroBanner';
import ImageWithFallback from '../../common/ImageWithFallback';
import type HeroBannerType from '../../../../types/HeroBanner';
import analytics from '../../../core/analytics/analytics';
import { PromotionType } from '../../../core/constants';
import tailwindConfig from '../../../../tailwind.config';
import CircleRight from '../../common/Icons/CircleRight';
import Button from '../../common/Button/Button';

type Props = {
  heroBanner?: HeroBannerType;
};

const HeroBanner = forwardRef<HTMLDivElement, Props>(({ heroBanner }) => {
  const events = {
    onClick: (banner?: HeroBannerType) => {
      analytics.google.ecommerce.track.promotion.view(
        {
          promotion_name: PromotionType.HERO_BANNER,
          promotion_id: banner?.url || '',
        },
        [
          {
            item_id: banner?.url || '',
            item_name: banner?.desktopContentImage?.altText || '',
          },
        ]
      );
    },
  };

  return (
    <>
      <div className="relative hidden h-[560px] w-full md:block">
        <ImageWithFallback
          data-testid="hero-banner-image"
          className="z-0 md:block"
          src={heroBanner?.desktopContentImage?.url || '/fallback-img-1440x440.png'}
          alt={heroBanner?.desktopContentImage?.altText || 'hero-banner-image'}
          layout="fill"
          sizes="100vw"
          quality={90}
          objectFit="cover"
          fallbackSrc="/fallback-img-1440x440.png"
        />
        {heroBanner?.description && heroBanner?.url && (
          <div className="absolute z-10 flex w-full justify-center sm:top-[240px] lg:top-[280px]">
            <Button
              className="flex h-10 w-fit max-w-full items-center gap-2 bg-black/60 pl-4 pr-2 text-white hover:opacity-90"
              rounded
              to={heroBanner.url}
              onClick={() => events.onClick(heroBanner)}
            >
              <p className="line-clamp-1 text-regular font-medium">{heroBanner.description}</p>
              <div className="w-6">
                <CircleRight size={24} color={tailwindConfig.theme.colors.white} />
              </div>
            </Button>
          </div>
        )}
      </div>

      {/* mobile view */}
      <div className="relative md:hidden" style={{ minWidth: 320 }}>
        <MobileHeroBanner heroBanner={heroBanner} />
      </div>
    </>
  );
});

HeroBanner.displayName = 'HeroBanner';

export default HeroBanner;
